import RestService from "~/core/services/rest.service";
import organizationService from "~/modules/organization/services/organization.service";
import type { FetchUserProfileParameters } from "~/modules/user/models/FetchUserProfileParameters.interface";
import type { UserProfile } from "~/modules/user/models/UserProfile.interface";

class UserProfileOrganizationService extends RestService {
  /**
   * Retrieve userProfiles
   */
  getUserProfiles({
    organizationCode,
    searchParams,
  }: FetchUserProfileParameters): Promise<UserProfile[]> {
    const params = {
      filter: searchParams,
    };

    return this.$apiV2.get(
      `${organizationService.getOrganizationPath(organizationCode)}/profiles`,
      {
        params,
      },
    );
  }
}

export default new UserProfileOrganizationService();
